<template>
  <div class="navbar">
    <div class="brand" @click="$router.push('/')" style="cursor: pointer;">
      <h2>Image Share</h2>
    </div>

    <div class="nav-links">
      <router-link to="/" class="nav-link" active-class="active">Gallery</router-link>
      <router-link to="/favorites" class="nav-link" active-class="active">Favorites</router-link>
      <router-link to="/add-character" class="btn btn-add">
        <i class="fas fa-plus"></i> Add
      </router-link>
    </div>
  </div>
</template>

<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css');

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--primary-color);
  padding: 15px 20px;
  color: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand h2 {
  margin: 0;
  font-size: 20px;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 20px;
}

.nav-link {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s;
}

.nav-link:hover, .nav-link.active {
  color: white;
}

.btn-add {
  background-color: var(--accent-color);
  color: white;
  text-decoration: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: opacity 0.3s;
}

.btn-add:hover {
  opacity: 0.9;
}

@media (max-width: 600px) {
  .navbar {
    flex-direction: column;
    gap: 15px;
  }
}
</style>